import React from 'react';
import { styled } from 'baseui';
import { HeadingXSmall, ParagraphMedium } from 'baseui/typography';
const StyledHeadingXSmall = styled(HeadingXSmall, ({
  $theme
}) => ({
  margin: 0,
  paddingTop: $theme.sizing.scale500,
  textAlign: 'center'
}));
const StyledParagraphMedium = styled(ParagraphMedium, ({
  $theme
}) => ({
  margin: 0,
  paddingTop: $theme.sizing.scale300,
  textAlign: 'center'
}));
const FooterContainer = styled('div', ({
  $theme
}) => ({
  paddingTop: $theme.sizing.scale600,
  textAlign: 'center'
}));
export const StatesRenderer = ({
  title,
  description,
  icon,
  footer
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  footer?: React.ReactNode;
}) => {
  return <>
      {icon}
      <StyledHeadingXSmall>{title}</StyledHeadingXSmall>
      <StyledParagraphMedium>{description}</StyledParagraphMedium>
      {footer && <FooterContainer>{footer}</FooterContainer>}
    </>;
};